export default __webpack_public_path__ + "static/media/drivers-licence.508d0729.png";